// extracted by mini-css-extract-plugin
export default {"img":"StaffSelectPage_img__OKMpn","container":"StaffSelectPage_container__0HzgJ","tools":"StaffSelectPage_tools__DCqhU"};